<template>
  <div 
    v-if="!isAndroid() && (!isHardwareServiceRunning || updatingHardware)" 
    class="network-status"
    :class="{ 'updating': updatingHardware }"
  >
    {{ statusMessage }}
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      isHardwareServiceRunning: true,
      checkInterval: null,
    };
  },
  computed: {
    updatingHardware() {
      return updatingHardware;
    },
    statusMessage() {
      return this.updatingHardware 
        ? 'Updating Hardware Service...' 
        : 'Hardware Service not detected, Please restart your computer';
    }
  },
  methods: {
    isAndroid() {
      return androidMode;
    },
    async checkHardwareService() {
      if (this.isAndroid()) {
        ("Android detected - skipping service check.");
        return;
      }
      try {
        const response = await axios.get("http://localhost:9090/printing/get");
        this.isHardwareServiceRunning = response.status === 200;
      } catch (error) {
        console.error("Error checking hardware service:", error.message);
        this.isHardwareServiceRunning = false;
      }
    },
    startChecking() {
      if (this.isAndroid()) {
        return;
      }
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
      }
      this.checkInterval = setInterval(() => {
        this.checkHardwareService();
      }, 4000);
    },
    stopChecking() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
        this.checkInterval = null;
      }
    }
  },
  created() {
    if (this.isAndroid()) {
      return;
    }
    this.checkHardwareService();
    this.startChecking();
  },
  beforeDestroy() {
    this.stopChecking();
  }
};
</script>

<style scoped>
.network-status {
  background-color: red;
  color: white;
  padding: 10px;
  text-align: center;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  animation: blink 1s infinite;
}

.network-status.updating {
  background-color: #2196F3; /* Blue color for updating state */
  animation: none; /* Remove blinking when updating */
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>
